module.exports = __webpack_public_path__ + "assets/alerts_primary.2a7cf577.svg";